import { useState, useEffect } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { useLocation } from 'react-router-dom';

import getPageSection from '#client/utils/getPageSection';
import { recordException } from '#client/utils/reporting';

export default function useAnchorElement(entityMenuRef, buttonRef) {
  const [anchorElement, setAnchorEl] = useState(null);
  const { pathname } = useLocation();

  const buttonPressedCallback = useButtonPressedCallback({
    elementAsset: 'user-outline.svg',
    elementName: 'user_menu_button',
    elementStyle: 'icon',
    pageCategory: 'dashboard',
    pageSection: getPageSection(pathname)
  });

  const onButtonClick = (event) => {
    buttonRef.current.blur();
    setAnchorEl(event.currentTarget);
    buttonPressedCallback();
  };

  const onMenuClose = () => {
    buttonRef.current.blur();
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!entityMenuRef.current) return;
    try {
      if (anchorElement) {
        entityMenuRef.current.querySelector('a')?.focus();
      }
    } catch (err) {
      recordException(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorElement, entityMenuRef.current]);

  return {
    anchorElement,
    onButtonClick,
    onMenuClose
  };
}
